module.exports = __webpack_public_path__ + "img/login_left.4d553540.png";